var _react_refresh_temp_1, _react_refresh_temp_2;
var _react_refresh_temp_3;
_react_refresh_temp_3 = $RefreshSig$();
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { C } from '#integrations';
import { CHECKBOX_GROUP_ITEM_KINDS } from '../../Checkbox.constants';
import { CheckboxTestIdFactory } from '../../interactions';
import styles from './CheckboxInput.module.css';
const KIND_CLASS_MAP = {
    default: styles.Default,
    compact: styles.Compact,
};
const ConditionalCheckboxLabel = ({ children, className, 'data-testid': testid, includeLabel = true, }) => includeLabel ? (_jsx("label", { className: className, "data-testid": CheckboxTestIdFactory.getCheckboxContainerTestId(testid), children: children })) : (_jsx(_Fragment, { children: children }));
_react_refresh_temp_1 = ConditionalCheckboxLabel;
$RefreshReg$(_react_refresh_temp_1, "ConditionalCheckboxLabel");
export const CheckboxInput = ({ 'aria-describedby': ariaDescribedBy, 'aria-errormessage': ariaErrorMessage, 'aria-hidden': ariaHidden, 'aria-invalid': ariaInvalid, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, className, 'data-testid': testid, description, disabled, id, includeLabel = true, isChecked, kind = CHECKBOX_GROUP_ITEM_KINDS.Default, label, name, onBlur, onChange, onFocus, ref, required, value, }) => {
    _react_refresh_temp_3();
    const [isFocused, setIsFocused] = useState(false);
    const shouldShowDetails = Boolean(label) || Boolean(description);
    return (_jsxs(ConditionalCheckboxLabel, { className: C(styles.Container, disabled && styles.Disabled, KIND_CLASS_MAP[kind], className), "data-testid": testid, includeLabel: includeLabel, children: [_jsx("div", { className: C(styles.CheckboxWrapper, isChecked && styles.CheckboxWrapperChecked, isFocused && styles.CheckboxWrapperFocused, disabled && styles.CheckboxWrapperDisabled), children: _jsx("input", { "aria-label": ariaLabel, checked: isChecked, className: C(styles.Checkbox, isChecked && styles.CheckboxChecked, disabled && styles.CheckboxDisabled), "data-testid": CheckboxTestIdFactory.getCheckboxInputTestId(testid), ...(disabled ? { disabled } : {}), id: id, name: name, onBlur: (event) => {
                        setIsFocused(false);
                        if (onBlur) {
                            onBlur(event);
                        }
                    }, onChange: () => {
                        if (typeof onChange === 'function') {
                            onChange(value);
                        }
                    }, onFocus: (event) => {
                        setIsFocused(true);
                        if (onFocus) {
                            onFocus(event);
                        }
                    }, ref: ref, required: required, type: "checkbox", value: value, ...(ariaDescribedBy && {
                        'aria-describedby': ariaDescribedBy,
                    }), ...(ariaLabelledBy && {
                        'aria-labelledby': ariaLabelledBy,
                    }), ...(ariaErrorMessage && {
                        'aria-errormessage': ariaErrorMessage,
                    }), ...(ariaInvalid && { 'aria-invalid': true }), ...(ariaHidden && { 'aria-hidden': true }) }) }), shouldShowDetails && (_jsxs("div", { className: styles.Details, children: [_jsx("p", { className: styles.Label, children: label }), description ? (_jsx("p", { className: styles.Description, "data-testid": CheckboxTestIdFactory.getCheckboxDescriptionTestId(testid), children: description })) : null] }))] }));
};
_react_refresh_temp_2 = CheckboxInput;
$RefreshReg$(_react_refresh_temp_2, "CheckboxInput");
_react_refresh_temp_3(CheckboxInput, "taoS6m9NZex5dx3pinefKTdpShE=");
